/* src/app/components/controls/dialogs/sem-o2m-section-dialog/sem-o2m-section-dialog.component.css */
.wg-o2m-dialog {
  display: flex;
  flex-direction: column;
  max-height: 88vh;
  background: #fff;
  border-radius: 16px;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
}
.wg-o2m-dialog-header {
  padding: 20px 32px 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-shrink: 0;
}
.wg-o2m-dialog-heading {
  min-width: 0;
}
.wg-o2m-dialog-header h3 {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.wg-o2m-dialog-header p {
  font-size: 12px;
  color: #94a3b8;
  margin: 2px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wg-o2m-dialog-close {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.wg-o2m-dialog-close:hover {
  background: #f1f5f9;
  color: #475569;
}
.wg-o2m-dialog-close .material-symbols-outlined {
  font-size: 18px;
}
.wg-o2m-dialog-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 32px;
}
.wg-o2m-dialog-body ::ng-deep .repeater-section {
  border: none;
  box-shadow: none;
  background: transparent;
  margin: 0;
  padding: 0;
}
.wg-o2m-dialog-body ::ng-deep .inner-manipulate-section,
.wg-o2m-dialog-body ::ng-deep .o2m-edit-actions {
  display: none;
}
.wg-o2m-dialog-footer {
  padding: 16px 32px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.wg-o2m-dialog-footer-spacer {
  flex: 1;
}
.wg-o2m-dialog-btn-cancel,
.wg-o2m-dialog-btn-save {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  border-radius: 10px;
  transition: all 0.15s ease;
}
.wg-o2m-dialog-btn-cancel {
  padding: 10px 16px;
  background: transparent;
  color: #64748b;
}
.wg-o2m-dialog-btn-cancel:hover {
  background: #f1f5f9;
  color: #475569;
}
.wg-o2m-dialog-btn-save {
  padding: 10px 20px;
  background:
    linear-gradient(
      135deg,
      #16a34a,
      #15803d);
  color: #fff;
  box-shadow: 0 2px 6px rgba(22, 163, 74, 0.3);
}
.wg-o2m-dialog-btn-save:hover {
  background:
    linear-gradient(
      135deg,
      #15803d,
      #166534);
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.35);
}
.wg-o2m-dialog-btn-save .material-symbols-outlined {
  font-size: 16px;
}
.wg-o2m-dialog-error {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #dc2626;
}
.wg-o2m-dialog-error .material-symbols-outlined {
  font-size: 16px;
  color: #ef4444;
}
/*# sourceMappingURL=sem-o2m-section-dialog.component.css.map */
